import { NotificationByUser } from 'types/notification';

export const STORAGE_KEY = 'mock_user_notifications';

// Datos mock iniciales - Las mismas 9 notificaciones del service actual
export const initialMockNotifications: NotificationByUser[] = [
    {
        message: {
            id: 1001,
            priority: 5,
            message:
                '<p><strong>Sebastián Balderas</strong> activated <strong>Product Approval</strong> and needs your validation.</p><p>I Bill I Vendor: VERSTEEL, I PO: 1761-01 I Invoice: 48549</p>',
            tenantId: 1,
            createdAt: Date.now() - 0 * 60 * 60 * 1000
        },
        userId: 1,
        roleId: 1,
        receivedAt: Date.now() - 0 * 60 * 60 * 1000,
        readAt: null,
        hide: false,
        important: true,
        module: 'Purchase Order',
        relatedCount: 7,
        pinned: false,
        muted: false
    },
    {
        message: {
            id: 1002,
            priority: 5,
            message: '<p><strong>Alejandro Moreno</strong> did not approve on time; it is now for your validation.</p>',
            tenantId: 1,
            createdAt: Date.now() - 1 * 60 * 60 * 1000
        },
        userId: 1,
        roleId: 1,
        receivedAt: Date.now() - 1 * 60 * 60 * 1000,
        readAt: null,
        hide: false,
        important: true,
        module: 'Purchase Order',
        relatedCount: 0,
        pinned: false,
        muted: false
    },
    {
        message: {
            id: 1003,
            priority: 5,
            message: '<p><strong>Alicia Scarth</strong> rejected this record and assigned it to you to resolve.</p>',
            tenantId: 1,
            createdAt: Date.now() - 2 * 60 * 60 * 1000
        },
        userId: 1,
        roleId: 1,
        receivedAt: Date.now() - 2 * 60 * 60 * 1000,
        readAt: null,
        hide: false,
        important: true,
        module: 'Purchase Order',
        relatedCount: 4,
        pinned: false,
        muted: false
    },
    {
        message: {
            id: 1004,
            priority: 3,
            message: '<p><strong>Alicia Scarth</strong> assigned you this record</p>',
            tenantId: 1,
            createdAt: Date.now() - 4 * 60 * 60 * 1000
        },
        userId: 1,
        roleId: 1,
        receivedAt: Date.now() - 4 * 60 * 60 * 1000,
        readAt: Date.now() - 3.5 * 60 * 60 * 1000,
        hide: false,
        important: false,
        module: 'Purchase Order',
        relatedCount: 0,
        pinned: false,
        muted: false
    },
    {
        message: {
            id: 1005,
            priority: 2,
            message: '<p><strong>Discount Due Date</strong> field is <strong>11/29/2025</strong>.</p>',
            tenantId: 1,
            createdAt: Date.now() - 5 * 60 * 60 * 1000
        },
        userId: 1,
        roleId: 1,
        receivedAt: Date.now() - 5 * 60 * 60 * 1000,
        readAt: Date.now() - 4.5 * 60 * 60 * 1000,
        hide: false,
        important: false,
        relatedCount: 0,
        pinned: false,
        muted: false
    },
    {
        message: {
            id: 1006,
            priority: 3,
            message: '<p><strong>Record Status</strong> field updated to <strong>Pending Review</strong></p>',
            tenantId: 1,
            createdAt: Date.now() - 6 * 60 * 60 * 1000
        },
        userId: 1,
        roleId: 1,
        receivedAt: Date.now() - 6 * 60 * 60 * 1000,
        readAt: Date.now() - 5.5 * 60 * 60 * 1000,
        hide: false,
        important: false,
        relatedCount: 0,
        pinned: false,
        muted: false
    },
    {
        message: {
            id: 1007,
            priority: 3,
            message: '<p><strong>Record Status</strong> field updated to <strong>Processed Manually</strong></p>',
            tenantId: 1,
            createdAt: Date.now() - 7 * 60 * 60 * 1000
        },
        userId: 1,
        roleId: 1,
        receivedAt: Date.now() - 7 * 60 * 60 * 1000,
        readAt: Date.now() - 6.5 * 60 * 60 * 1000,
        hide: false,
        important: false,
        relatedCount: 0,
        pinned: false,
        muted: false
    },
    {
        message: {
            id: 1008,
            priority: 2,
            message: '<p><strong>Sebastián Balderas</strong> created this record</p>',
            tenantId: 1,
            createdAt: Date.now() - 8 * 60 * 60 * 1000
        },
        userId: 1,
        roleId: 1,
        receivedAt: Date.now() - 8 * 60 * 60 * 1000,
        readAt: Date.now() - 7.5 * 60 * 60 * 1000,
        hide: false,
        important: false,
        relatedCount: 0,
        pinned: false,
        muted: false
    },
    {
        message: {
            id: 1009,
            priority: 4,
            message:
                '<p>Download ready <strong>Invoice, Vendor: Flock Freight Inc., PO: PO-UD-21661/CORINN/7869/IF3445D: 122440</strong></p>',
            tenantId: 1,
            createdAt: Date.now() - 9 * 60 * 60 * 1000
        },
        userId: 1,
        roleId: 1,
        receivedAt: Date.now() - 9 * 60 * 60 * 1000,
        readAt: Date.now() - 8.5 * 60 * 60 * 1000,
        hide: false,
        important: false,
        relatedCount: 0,
        pinned: false,
        muted: false
    }
];

// Helper para generar nuevas notificaciones aleatorias
export const generateRandomNotification = (): NotificationByUser => {
    const now = Date.now();
    const messages = [
        '<p><strong>Sebastián Balderas</strong> activated <strong>Product Approval</strong> and needs your validation.</p>',
        '<p><strong>Alejandro Moreno</strong> did not approve on time; it is now for your validation.</p>',
        '<p><strong>Alicia Scarth</strong> rejected this record and assigned it to you to resolve.</p>',
        '<p><strong>Alicia Scarth</strong> assigned you this record</p>',
        '<p><strong>Discount Due Date</strong> field is <strong>11/29/2025</strong>.</p>',
        '<p><strong>Record Status</strong> field updated to <strong>Pending Review</strong></p>',
        '<p><strong>Record Status</strong> field updated to <strong>Processed Manually</strong></p>',
        '<p><strong>Sebastián Balderas</strong> created this record</p>',
        '<p>Download ready <strong>Invoice, Vendor: Flock Freight Inc., PO: PO-UD-21661/CORINN/7869/IF3445D: 122440</strong></p>'
    ];

    const modules = ['Purchase Order', 'Purchase Order', 'Purchase Order', 'Purchase Order', null, null, null, null, null];
    const relatedCounts = [7, 0, 4, 0, 0, 0, 0, 0, 0];

    const randomIndex = Math.floor(Math.random() * messages.length);
    const randomPriority = Math.floor(Math.random() * 5) + 1;
    const isImportant = Math.random() > 0.8;

    return {
        message: {
            id: now,
            priority: randomPriority,
            message: messages[randomIndex],
            tenantId: 1,
            createdAt: now
        },
        userId: 1,
        roleId: 1,
        receivedAt: now,
        readAt: null,
        hide: false,
        important: isImportant,
        module: modules[randomIndex] || undefined,
        relatedCount: relatedCounts[randomIndex] || 0,
        pinned: false,
        muted: false
    };
};
